import { Suspense, type PropsWithChildren } from 'react'
import { Outlet, useParams } from 'react-router-dom'

import { LocationInputProvider } from 'src/shared/features/users/components/marketplace/context/use-location-input'
import PublicProfileMobileHeader from 'src/shared/features/users/components/public-profile/mobile-header'
import PublicUserProfileCard from 'src/shared/features/users/components/public-profile/public-profile-user-card'
import PublicProfileSkeleton from 'src/shared/features/users/components/public-profile/skeleton/public-profile-skeleton'
import PublicProfileHeader from 'src/shared/features/users/components/public-profile/ui/header'
import { useWindowSize } from 'src/shared/hooks/use-window-size'

const PublicProfileLayoutContent = ({ children, profile = false }: PropsWithChildren<{ profile?: boolean }>) => {
  const { width } = useWindowSize()
  const { username } = useParams<{ username: string }>()

  return (
    <LocationInputProvider>
      <div className="flex min-h-screen w-full flex-col">
        <PublicProfileHeader />
        <main className="mx-auto mt-[70px] w-full px-0 md:mt-[132px] md:px-8">
          {profile && width > 768 ? (
            <div className="flex w-full flex-row justify-center gap-6 xl:gap-[40px]">
              <div className="sticky top-[102px] flex flex-col items-start gap-4 self-start pb-4 md:top-[132px]">
                <PublicUserProfileCard username={username} />
              </div>
              <div>{children || <Outlet />}</div>
            </div>
          ) : (
            <div className="flex w-full flex-col gap-4">
              <PublicProfileMobileHeader />
              <div className="w-full px-5">{children || <Outlet />}</div>
            </div>
          )}
        </main>
      </div>
    </LocationInputProvider>
  )
}

const PublicProfileLayout = ({ children, profile = false }: PropsWithChildren<{ profile?: boolean }>) => {
  return (
    <Suspense fallback={<PublicProfileSkeleton />}>
      <PublicProfileLayoutContent profile={profile}>{children}</PublicProfileLayoutContent>
    </Suspense>
  )
}

export default PublicProfileLayout
